module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.636/icons/Menu.svg"